// Amber-gradient CTA styling applied via `sx` on contained buttons. The theme's
// MuiButton "warning" variant (themes.js) carries the same look globally, so this
// helper is for buttons that do NOT pass `color="warning"` (the theme variant
// can't reach them) but still want the amber CTA look via `sx={amberCtaSx}`.
// Reads from `theme.custom.wizard`; the hard-coded fallbacks are defensive only.
// Keep these values in sync with the themes.js amber* tokens.

export function amberCtaSx(theme) {
    const w = theme.custom?.wizard ?? {};
    const motion = w.motion ?? {};
    const grad = w.amberGradient ?? "linear-gradient(180deg, #E8893B 0%, #D87B30 100%)";
    const shadow = w.amberShadow ?? "0 8px 24px rgba(232,137,59,0.35)";
    const shadowHover = w.amberShadowHover ?? "0 11px 28px rgba(232,137,59,0.40)";
    const glowMs = motion.toggle ?? "220ms";
    const easing = motion.easing ?? "ease-out";

    return {
        background: grad,
        color: theme.palette.warning.contrastText,
        border: "none",
        borderRadius: `${w.fieldRadius ?? 10}px`,
        paddingY: 1.25,
        fontWeight: 700,
        // letterSpacing: "0.05em",
        textTransform: "uppercase",
        boxShadow: `inset 0 1px 0 rgba(255,255,255,0.20), ${shadow}`,
        // Hover lifts via light, not geometry: only the amber glow swells, the
        // button never moves. A sub-pixel position nudge reads as a twitch no
        // matter how slow — so elevation is implied by the deepening shadow alone.
        transition: `box-shadow ${glowMs} ${easing}`,
        "&:hover": {
            background: grad,
            boxShadow: `inset 0 1px 0 rgba(255,255,255,0.20), ${shadowHover}`,
        },
        // Disabled reads as a flat, inert grey rather than a dimmed amber — a
        // 0.45-opacity gradient looked like a muted-but-clickable button.
        "&.Mui-disabled": {
            background: "rgba(244,242,238,0.10)",
            color: "rgba(244,242,238,0.40)",
            boxShadow: "none",
        },
        "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
        },
    };
}
